/* tslint:disable */
/* eslint-disable */

/**
 * deliveryProviderPortal paid-visibility api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, type GeneratedHttpClientConstraints, type RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    GetMenuItemsPreviewRequest,
    GetMenuItemsPreviewResponse,
    GetPaidVisibilityOffersRequest,
    GetPaidVisibilityOffersResponse,
    GetProviderPreviewRequest,
    GetProviderPreviewResponse,
    GetSponsoredListingRequest,
    GetSponsoredListingResponse,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.JWT;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}



class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public paidVisibilityGetAvailableOffers = async (body: GetPaidVisibilityOffersRequest, opts?: TRequestOptions): Promise<GetPaidVisibilityOffersResponse>  => {
            return this.httpClient.sendRequest<GetPaidVisibilityOffersResponse>({
                path: '/deliveryProviderPortal/paidVisibility/getAvailableOffers',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityGetMenuItemsPreview = async (body: GetMenuItemsPreviewRequest, opts?: TRequestOptions): Promise<GetMenuItemsPreviewResponse>  => {
            return this.httpClient.sendRequest<GetMenuItemsPreviewResponse>({
                path: '/deliveryProviderPortal/paidVisibility/getMenuItemsPreview',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityGetProviderPreview = async (body: GetProviderPreviewRequest, opts?: TRequestOptions): Promise<GetProviderPreviewResponse>  => {
            return this.httpClient.sendRequest<GetProviderPreviewResponse>({
                path: '/deliveryProviderPortal/paidVisibility/getProviderPreview',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityGetSponsoredListing = async (body: GetSponsoredListingRequest, opts?: TRequestOptions): Promise<GetSponsoredListingResponse>  => {
            return this.httpClient.sendRequest<GetSponsoredListingResponse>({
                path: '/deliveryProviderPortal/paidVisibility/getSponsoredListing',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
